import { Dispatch, useContext, createContext } from 'react';
import { ActionType } from './actions';
import { FullEventFragment } from '@/generated/graphql';

export type ScreenInfo = Pick<
  FullEventFragment,
  'name' | 'date' | 'location' | 'description'
>;

export const defaultInitialState: ScreenInfo = {
  name: '',
  date: '',
  location: '',
  description: '',
};

export interface ScreenInfoContextType {
  dispatch: Dispatch<ActionType>;
  state: ScreenInfo;
}

export const screenInfoContext = createContext<ScreenInfoContextType>({
  dispatch: () => {},
  state: defaultInitialState,
});

export function useScreenInfo() {
  return useContext(screenInfoContext);
}
